/*
    |---------------------------------------------------------------------------
    | Actualizacion _ga para el back
    |---------------------------------------------------------------------------
    |* @param  Function  fn   Funcion callback a ejecutar
    */

import { getCookie } from './getCookie'
import { loadScript } from './loadScript'
import { GLOBAL_VARIABLES } from '../config'

export function updateGaBackEnd() {
  // WS que necesita back para grabar el _ga
  const { Piwik } = window
  console.log('Actualizar analytics')
  let idlepiwik = 0
  const intervalPiwik = setInterval(function() {
    if (idlepiwik >= 30) {
      clearInterval(intervalPiwik)
      return false
    }

    if (Boolean(Piwik) && Boolean(Piwik.getAsyncTracker()) && Boolean(Piwik.getAsyncTracker().getVisitorId())) {
      const url = 'https://t.womtp.com/epst' +
        '?idsite=' + GLOBAL_VARIABLES.idTagDelioClient +
        '&idvisitor=' + Piwik.getAsyncTracker().getVisitorId() +
        '&gaid=' + getCookie('_ga').replace('GA1.2.', '')

      loadScript(url, () => {
        clearInterval(intervalPiwik)
      })
    }
    idlepiwik += 1
  }, 100)
}
